/**
 * Imperative re-exports over sdk-utils' `useNotificationStore`: sugar so
 * consumers don't have to dig into `/store` for the imperative API.
 */

import {
  useNotificationStore,
  notifySuccess,
  notifyError,
  notifyInfo,
  notifyWarning,
  type NotificationInput,
  type Notification
} from '@repletoryreach/sdk-utils/store';

/** Generic push. Returns the id for later `hide(id)`. */
export function show(input: NotificationInput): string {
  return useNotificationStore.getState().push(input);
}

/** Dismiss by id. */
export function hide(id: string): void {
  useNotificationStore.getState().dismiss(id);
}

/** Clear all. */
export function cleanNotifications(): void {
  useNotificationStore.getState().clear();
}

/** Update an existing notification in place. */
export function updateNotification(id: string, patch: Partial<Notification>): void {
  useNotificationStore.getState().update(id, patch);
}

export { notifySuccess, notifyError, notifyInfo, notifyWarning };
export type { NotificationInput, Notification };
